import React from 'react';
import Link from '../components/Link';
import Line from '../components/Line';
import Image from '../components/Image';
import CommissionText from '../components/CommissionText';
import {
    williamhill as williamhillUrls,
    common as commonUrls,
} from '../urlConstants';
import '../styles.scss';

const WilliamHill = () => (
    <div className="bs-gamblingCompliance">
        <div className="bs-gamblingCompliance__message">
            <Line className="bs-gamblingCompliance__line--spacer">
                Bets are accepted in accordance with the operator&#39;s&nbsp;
                <Link
                    href={williamhillUrls.rules}
                    text="rules"
                />.
            </Line>
            <Line className="bs-gamblingCompliance__line--spacer">
                William Hill is licensed and regulated by the&nbsp;
                <Link
                    href={williamhillUrls.license}
                    text="UK Gambling Commission no. 000-039225 R-319373-001"
                />
            </Line>
            <Line className="bs-gamblingCompliance__line--spacer">
                The registered office of William Hill is at 6/1 Waterport Place,
                Gibraltar, with registered company number 99191.
            </Line>
            <Line>
                William Hill is committed to supporting&nbsp;
                <Link
                    href={williamhillUrls.responsibleGambling}
                    text="Responsible Gambling"
                />
            </Line>
            &nbsp;
            <CommissionText />
        </div>
        <div className="bs-gamblingCompliance__images">
            <Image
                href={williamhillUrls.underage}
                imageName="underageRed"
            />
            <Image href={commonUrls.gamaware} imageName="gamaware" />
            <Image href={commonUrls.gamcare} imageName="gamcare" />
            <Image href={commonUrls.gamtherapy} imageName="gamtherapyTransparent" />
            <Image href={commonUrls.raig} imageName="raig" />
        </div>
        <div className="bs-gamblingCompliance__message">
            Underage gambling is an offence
        </div>
    </div>
);

export default WilliamHill;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/WilliamHill/fullGamblingCompliance.jsx